import React from 'react';
import { ChevronLeft, ChevronRight, ChevronDown } from 'lucide-react';
import Button from './Button';
import Dropdown from './Dropdown';
import { formatDateRange } from '../../utils/dateRange';

// =============================================================================
// PeriodNav — the shared ◀ [range label] ▶ timeline pill (Sep 2026).
//
// Used by BOTH the Final Roster and the Management Console so timeline
// language is identical everywhere: "Mon 1 – Sun 7 Sep" via formatDateRange.
//
//   startDate / endDate : Date objects (inclusive) — the label
//   label               : optional string override (on-call months: "Sep 2026")
//   onPrev / onNext     : arrow handlers
//   menu                : optional Dropdown items — the label then becomes a
//                         chevron'd trigger (Final Roster's Week/Fortnight
//                         span choice lives here)
// =============================================================================

const PeriodNav = ({
  startDate,
  endDate,
  label,
  onPrev,
  onNext,
  menu = null,
  className = '',
  minLabelWidth = 'min-w-[160px]',   // the same on every tab (Oct 2026)
}) => {
  const text = label || (startDate && endDate ? formatDateRange(startDate, endDate) : '');
  const labelClasses = `text-[10px] font-bold text-slate-700 uppercase tracking-widest text-center whitespace-nowrap px-2 ${minLabelWidth}`;

  return (
    <div className={`flex items-center gap-1.5 bg-slate-100 p-1 rounded-lg border border-slate-200 shadow-inner h-[36px] ${className}`}>
      <Button
        variant="ghost" size="icon" icon={ChevronLeft} onClick={onPrev}
        aria-label="Previous period"
        className="h-[28px] w-[28px] hover:bg-white shadow-none"
      />
      {menu ? (
        <Dropdown
          align="left"
          items={menu}
          renderTrigger={({ toggle }) => (
            <button
              type="button"
              onClick={toggle}
              className={`${labelClasses} inline-flex items-center justify-center gap-1 hover:text-slate-900`}
              style={{ background: 'transparent', boxShadow: 'none' }}
            >
              <span>{text}</span>
              <ChevronDown className="w-3 h-3 opacity-50" />
            </button>
          )}
        />
      ) : (
        <span className={labelClasses}>{text}</span>
      )}
      <Button
        variant="ghost" size="icon" icon={ChevronRight} onClick={onNext}
        aria-label="Next period"
        className="h-[28px] w-[28px] hover:bg-white shadow-none"
      />
    </div>
  );
};

export default PeriodNav;
